export const FAQS_TO_LOAD = 4
